<template>
  <div class="infoTable mb-3">
    <v-layout row wrap>
      <v-flex xs12>
        <v-icon small class="k-orange-linear-text">fas fa-stream</v-icon>
        <span class="subheading font-weight-medium">Otra información</span>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-2>
      <template v-if="dimentions.length > 0">
        <template v-for="(dimention, i) in dimentions">
          <v-flex md3 :mt-2="i > 3" :key="i" v-if="Object.keys(dimention.items.find(x => x.id === customer[dimention.field]) || {}).length">
            <small>{{ dimention.title }}</small>
            <br />
            <p
              class="caption"
            >{{ (dimention.items.find(x => x.id === customer[dimention.field]) || {}).name }}</p>
          </v-flex>
        </template>
      </template>
      <v-flex md3 v-if="portfolioBenchmarkName">
        <small>Portfolio benchmark</small>
        <br />
        <p class="caption">
          {{ portfolioBenchmarkName }}
        </p>
      </v-flex>
      <template v-for="info in 10">
        <v-flex md3 :key="`info-${info}`" v-if="customer[`info_${info}`]">
          <small>Info {{ info }}</small>
          <br />
          <p class="caption">
            {{ customer[`info_${info}`] }}
          </p>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    dimentions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      portfolioBenchmarkName: null,
    };
  },
  watch: {
    'customer.portfolio_benchmark_id': {
      immediate: true,
      handler(id) {
        this.fetchPortfolioBenchmark(id);
      },
    },
  },
  methods: {
    fetchPortfolioBenchmark(id) {
      this.portfolioBenchmarkName = null;
      if (!id) {
        return;
      }
      this.axios.get(`filters/portfolio_benchmarks/${id}`).then(({ data }) => {
        this.portfolioBenchmarkName = data.name || 'Sin información';
      }).catch(() => {
        this.portfolioBenchmarkName = 'Sin información';
      });
    },
  },
};
</script>

<style scoped lang="css">
  .infoTable {
    border: 1px solid #d0c9c9;
    border-width: 0.5px;
    padding: 4px 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/OtherInfo.vue